var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'level-item': true,
    button: true,
    'is-toggle': true,
    'is-on': _vm.isShowAssignations
  },attrs:{"title":_vm.$t(_vm.isShowAssignations ? 'tasks.hide_assignations' : 'tasks.show_assignations')},on:{"click":_vm.toggleAssignations}},[_c('users-icon',{staticClass:"icon is-small"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }